import { z } from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';
import { practiceMemberIdSchema } from '@nesso/common-contracts/ids';

import { transcriptSchema } from './transcript.models';

export const GET_TRANSCRIPT_BY_ID_TYPE = 'transcript/get-by-id';
export const GET_TRANSCRIPT_METADATA_TYPE = 'transcript/get-metadata';

export const getTranscriptById = defineQuery(
    GET_TRANSCRIPT_BY_ID_TYPE,
    z.object({
        id: z.uuid(),
        practiceMemberId: practiceMemberIdSchema,
    }),
    z.object({
        content: transcriptSchema,
    }),
);

export const getTranscriptMetadata = defineQuery(
    GET_TRANSCRIPT_METADATA_TYPE,
    z.object({
        id: z.uuid(),
        practiceMemberId: practiceMemberIdSchema,
    }),
    z.object({
        expiresAt: z.iso.datetime(),
    }),
);
